<script>
    export default {
        props: {
            windowOpenPublishMedia: {
                type: Boolean
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                selectedMediaData: [],
            }
        },
        computed: {
            mediaSelected: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            previewMedia() {
                let previewMedia = this.selectedMediaData;

                // Used to show media immediatly after opening the lightbox, instead of waiting for ajax call
                if (!previewMedia.length) {
                    previewMedia = _.map(this.mediaSelected, function (id) {
                        return {id};
                    })
                }

                return _.slice(previewMedia, 0, 7);
            }
        },
        watch: {
            windowOpenPublishMedia: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue) {
                        this.loadData();

                        this.$nextTick(() => {
                            $(this.$refs.publishMedia).on('hidden.bs.modal', () => {
                                this.close();
                            }).modal('show');
                        });
                    } else if (oldValue) {
                        $(this.$refs.publishMedia).modal('hide');
                        scoopOS.deselectAll('medias');
                    }
                },
            }
        },
        methods: {
            loadData() {
                axios.get(Scoop.baseUrl + '/component/publish-media').then((response) => {
                    this.selectedMediaData = response.data.selectedMediaData;
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                });
            },
            publish() {
                let parameter = {
                    'selectedMedia': this.mediaSelected
                };

                axios.post(Scoop.baseUrl + '/component/publish-media', parameter).then((response) => {
                    this.close();
                    window.location.replace(window.location.href);
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                });
            },
            close() {
                this.$emit('close');
            }
        },
    }
</script>
<template>
    <div ref="publishMedia" class="modal inmodal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Publish media</h4>
                    <small class="font-bold">
                        <img
                                v-for="media in previewMedia"
                                :src="media.previewImageUrl"
                                width="30" height="30"
                                class="img-thumbnail img-md m-r-xs"
                                :class="{ 'panel-primary bg-danger': false }"
                        >
                        <span v-if="mediaSelected.length > previewMedia.length">
                            + {{ mediaSelected.length - previewMedia.length }}
                        </span>
                    </small>
                </div>
                <div class="modal-footer">
                    <div class="pull-left">
                        <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                    </div>
                    <button @click.prevent="publish" type="button" class="btn btn-primary">
                        Publish media
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
